import { vec3, vec4 } from 'gl-matrix';
import type { Face } from './Face';

export class Vertex {
  public position: vec3;
  public color: vec4;
  public normal: vec3;
  public partOfFaces: Face[];

  constructor() {
    this.position = vec3.create();
    this.color = vec4.create();
    this.normal = vec3.create();
    this.partOfFaces = [];
  }

  public setPosition(position: vec3 | number[]): Vertex {
    vec3.copy(this.position, position as vec3);
    return this;
  }

  public setColor(color: vec4 | number[]): Vertex {
    vec4.copy(this.color, color as vec4);
    return this;
  }

  public setNormal(normal: vec3 | number[]): Vertex {
    vec3.copy(this.normal, normal as vec3);
    return this;
  }

  // Average the normals of all adjacent faces and store the unit-length result.
  // Used by smooth-shaded primitives where vertices are shared between faces.
  public calculateNormal(): Vertex {
    vec3.set(this.normal, 0, 0, 0);
    for (const face of this.partOfFaces) {
      vec3.add(this.normal, this.normal, face.normal);
    }
    vec3.normalize(this.normal, this.normal);
    return this;
  }

  public getDistance(location: vec3 | number[]): number {
    return vec3.distance(this.position, location as vec3);
  }
}
